<div class="background">

</div>
<div class="container text-color-inverse text-center circles">
  <div class="circle circle-pincode"></div>
  <div class="container-small">

    <h1 class="mb-1">{{'pincode.title' | translate}} <strong>{{'pincode.app-name' | translate}}</strong></h1>
    <p class="homeText mt-1">{{'pincode.header' | translate}}</p>

    <code-input [initialFocusField]="0" [isCodeHidden]="false" [codeLength]="5" (codeCompleted)="onCodeCompleted($event)" class="fade-up"></code-input>
    @if (error !== null) {
      <div class="error-message">{{ error }}</div>
    }
  </div>
</div>
